// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3pjVg","buttons":"PendingPaymentAlert_buttons__1FZb9"};